var map = {
	"./": 19420,
	"./InstaVolt-logo-pin.png": 86945,
	"./Verified.svg": 53755,
	"./accumulated-volts.svg": 45544,
	"./add-note.svg": 35397,
	"./add.svg": 44144,
	"./admin-logo.png": 86760,
	"./advertising.svg": 61263,
	"./amex.svg": 87118,
	"./arrow-mobile.svg": 80237,
	"./assign-charge-stations.svg": 10401,
	"./assing.svg": 39142,
	"./association-remove.svg": 33553,
	"./available-credit.svg": 53262,
	"./avatar.svg": 32696,
	"./back-arrow-b.svg": 32271,
	"./back-arrow.svg": 33622,
	"./barcode.jpg": 98783,
	"./bulk-create.svg": 45952,
	"./cancel-pending-transactions.svg": 65031,
	"./change-version.svg": 19296,
	"./charge-sessions.svg": 43087,
	"./charging.svg": 98042,
	"./check-red.svg": 91083,
	"./check.svg": 96729,
	"./checkgreen.svg": 59542,
	"./claimRFIDCardReader.svg": 49937,
	"./claimed-volts.svg": 51081,
	"./close-b.svg": 81140,
	"./close.svg": 7733,
	"./closing-balance.svg": 17151,
	"./confirmation.svg": 34592,
	"./cpos.svg": 49636,
	"./credit-card-bg.png": 57893,
	"./currencyConversionInfo.png": 41406,
	"./current-balance.svg": 35157,
	"./dankort.svg": 10088,
	"./dashboard-btn.svg": 5598,
	"./dashboard.svg": 15501,
	"./data-loader.gif": 14212,
	"./delete-red.svg": 77416,
	"./delete.svg": 10154,
	"./diners_club_carte_blanche.svg": 68419,
	"./disable-referral.svg": 4813,
	"./disabled-red.svg": 21673,
	"./disabled.svg": 33091,
	"./discover.svg": 99342,
	"./disputed.svg": 81523,
	"./down-arrow.svg": 75927,
	"./down.svg": 51603,
	"./download-locations.svg": 39268,
	"./drivers-grey.svg": 83448,
	"./drivers-r.svg": 45221,
	"./drivers.svg": 80360,
	"./drop-down-arrow.svg": 80069,
	"./dropdown-menu.svg": 52708,
	"./dropdown-menu_vertical.svg": 41781,
	"./duplicate.svg": 67718,
	"./edit.svg": 46343,
	"./enable-2FA.svg": 76304,
	"./enable-referral.svg": 20440,
	"./enable.svg": 43054,
	"./energy.svg": 81795,
	"./error-icon.svg": 18683,
	"./expense.svg": 59729,
	"./expired-volts.svg": 95053,
	"./export-list.svg": 34654,
	"./export.svg": 35853,
	"./fake-account.svg": 27766,
	"./favicon.ico": 30804,
	"./filter-b.svg": 12288,
	"./filter.svg": 14969,
	"./financial-details.svg": 6789,
	"./flash.svg": 12351,
	"./fleet-settings.svg": 74477,
	"./forward.svg": 83570,
	"./generate-token.svg": 19858,
	"./grey-charger.png": 26931,
	"./has-menu-arrow.svg": 24519,
	"./help-02.svg": 31417,
	"./help.svg": 69322,
	"./help_r.svg": 57025,
	"./history.svg": 90777,
	"./ic-approval.svg": 99333,
	"./ic-assign-permission.svg": 17445,
	"./ic-assign.svg": 80887,
	"./ic-attach-vat.svg": 88129,
	"./ic-copy.svg": 46331,
	"./ic-date.svg": 62424,
	"./ic-detail.svg": 80583,
	"./ic-device.svg": 89906,
	"./ic-download.svg": 64196,
	"./ic-edit.svg": 79368,
	"./ic-generate-CDR.svg": 13359,
	"./ic-information.svg": 54534,
	"./ic-rfid-cards.svg": 72769,
	"./ic-video.svg": 74997,
	"./ic-volt.svg": 79145,
	"./import.svg": 75568,
	"./index": 19420,
	"./index.ts": 19420,
	"./info-icon.svg": 14927,
	"./jcb.svg": 71492,
	"./laser.svg": 97416,
	"./letter-history.svg": 68524,
	"./lock.svg": 97026,
	"./login-background.jpg": 8543,
	"./login-bg-shapes-02.svg": 84264,
	"./login-bg-shapes.svg": 2005,
	"./login-icon.svg": 54676,
	"./logo.png": 82806,
	"./logout.svg": 10589,
	"./logs-grey.svg": 12474,
	"./maestro.svg": 13502,
	"./marker_big.svg": 47206,
	"./mastercard.svg": 13331,
	"./masters.svg": 26468,
	"./no-data-found.jpg": 96910,
	"./no-data.png": 9977,
	"./no-image-found.jpg": 70569,
	"./notes-icon.svg": 23148,
	"./nxtar-last.svg": 30631,
	"./nxtar.svg": 55834,
	"./organisations.svg": 73848,
	"./organizations-active.svg": 44984,
	"./partial_pay.svg": 9145,
	"./payment-fail.svg": 22420,
	"./payment.svg": 30423,
	"./payment_gray.svg": 73111,
	"./permission-w.svg": 99182,
	"./permission.svg": 4002,
	"./pin.png": 17310,
	"./play.svg": 55789,
	"./prevar-first.svg": 93404,
	"./prevar.svg": 53973,
	"./process.gif": 8411,
	"./profile.svg": 42198,
	"./promotions.svg": 83229,
	"./promotions_gray.svg": 16061,
	"./promotions_r.svg": 8546,
	"./re-generate-token.svg": 82016,
	"./re-handshake.svg": 28644,
	"./refund.svg": 30025,
	"./refund_b.svg": 95414,
	"./regions/IS/InstaVolt-logo-pin.png": 17164,
	"./regions/IS/accumulated-volts.svg": 62717,
	"./regions/IS/admin-logo.png": 45825,
	"./regions/IS/assign-charge-stations.svg": 9998,
	"./regions/IS/assing.svg": 94021,
	"./regions/IS/association-remove.svg": 11614,
	"./regions/IS/available-credit.svg": 11117,
	"./regions/IS/avatar.svg": 97427,
	"./regions/IS/back-arrow.svg": 93213,
	"./regions/IS/bulk-create.svg": 70513,
	"./regions/IS/check-red.svg": 81986,
	"./regions/IS/claimRFIDCardReader.svg": 89364,
	"./regions/IS/claimed-volts.svg": 83188,
	"./regions/IS/closing-balance.svg": 55102,
	"./regions/IS/confirmation.svg": 77655,
	"./regions/IS/currencyConversionInfo.png": 22555,
	"./regions/IS/current-balance.svg": 49868,
	"./regions/IS/dashboard-btn.svg": 62307,
	"./regions/IS/disabled-red.svg": 72658,
	"./regions/IS/download-locations.svg": 17395,
	"./regions/IS/drivers-r.svg": 91028,
	"./regions/IS/expired-volts.svg": 55168,
	"./regions/IS/export-list.svg": 68452,
	"./regions/IS/export.svg": 17154,
	"./regions/IS/flash.svg": 86166,
	"./regions/IS/help-02.svg": 19876,
	"./regions/IS/help.svg": 18929,
	"./regions/IS/help_r.svg": 89566,
	"./regions/IS/import.svg": 90647,
	"./regions/IS/login-bg-shapes.svg": 11020,
	"./regions/IS/logo.png": 74107,
	"./regions/IS/marker_big.svg": 86405,
	"./regions/IS/no-data-found.jpg": 47825,
	"./regions/IS/no-data.png": 68658,
	"./regions/IS/organizations-active.svg": 30751,
	"./regions/IS/payment-fail.svg": 59547,
	"./regions/IS/promotions_r.svg": 97281,
	"./regions/IS/rfid-cards-red.svg": 27231,
	"./regions/IS/status-change-red.svg": 98557,
	"./regions/IS/synchronize.svg": 70474,
	"./regions/IS/tariff.svg": 20778,
	"./regions/IS/unbilled-amount.svg": 61654,
	"./regions/IS/volts-liability.svg": 97518,
	"./replace.svg": 60085,
	"./reset-icon.svg": 29622,
	"./reset-password.svg": 6086,
	"./rfid-cards-grey.svg": 56254,
	"./rfid-cards-red.svg": 97136,
	"./rfid-cards.svg": 28834,
	"./right_arrow.svg": 25253,
	"./send-email.svg": 12954,
	"./settings-grey.svg": 97028,
	"./settings.svg": 84756,
	"./sorting.svg": 5209,
	"./sorting_asc.svg": 33175,
	"./sorting_desc.svg": 50823,
	"./stations-b.svg": 18089,
	"./stations.svg": 74980,
	"./status-change-red.svg": 52048,
	"./status-change.svg": 26754,
	"./subscription.svg": 88056,
	"./success-icon.svg": 79198,
	"./synchronize.svg": 23811,
	"./tags-b.svg": 121,
	"./tags.svg": 89428,
	"./tariff-grey.svg": 77423,
	"./tariff.svg": 12769,
	"./transaction-logs.svg": 55535,
	"./transactions-b.svg": 94081,
	"./transactions.svg": 47788,
	"./uatp.svg": 49537,
	"./unbilled-amount.svg": 58727,
	"./undo.svg": 11297,
	"./unlock.svg": 86371,
	"./user-sessions.svg": 57872,
	"./users.svg": 86477,
	"./vat.svg": 2544,
	"./visa.svg": 48932,
	"./visa_electron.svg": 52381,
	"./volts-liability.svg": 6387,
	"./warning-icon.svg": 51581
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 73811;